import React, { useRef, useState, useCallback } from 'react';

import { Container, Row, Col, animateScroll } from 'aplazame-design-system';
import { useTranslate } from 'soluble-gatsby-source';

import HeaderResourcesSection from '../HeaderResourcesSection';
import CardGuideComponent from '../CardGuideComponent';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';

let HAS_INITED = false;

export default function GuidesSection({
    title,
    subtitle,
    detachedGuides,
    guides,
    categories,
}) {
    const translation = useTranslate();
    const wrapperRef = useRef();
    const [filteredGuides, setFilteredGuides] = useState(guides);

    const onFilterChange = useCallback(
        (filter) => {
            if (filter && filter.slug) {
                if (guides && guides.length) {
                    setFilteredGuides(
                        guides.filter(
                            (g) => g.category && g.category.slug === filter.slug
                        )
                    );
                }
            } else {
                setFilteredGuides(guides);
            }

            if (!HAS_INITED) {
                HAS_INITED = true;
            } else if (wrapperRef && wrapperRef.current) {
                let offsetTop = wrapperRef.current.offsetTop;
                const rect = wrapperRef.current.getBoundingClientRect();
                const scrollTop =
                    window.pageYOffset ||
                    window.document.documentElement.scrollTop;
                if (rect && rect.top) {
                    offsetTop = rect.top + scrollTop;
                }

                animateScroll(offsetTop, -160, 0.5);

                setTimeout(() => {
                    const allDataSal = wrapperRef.current.querySelectorAll(
                        '[data-sal]'
                    );
                    [...allDataSal].forEach((item) => {
                        item.classList.add('sal-animate');
                    });
                }, 200);
            }
        },
        [guides, setFilteredGuides, wrapperRef]
    );

    return (
        <>
            <HeaderResourcesSection
                title={title}
                subtitle={subtitle}
                categories={categories}
                allCategoriesTitle={
                    translation['guides-section.categories.all'].text
                }
                onFilterChange={onFilterChange}
                extraContent={
                    detachedGuides && detachedGuides.length ? (
                        <div
                            className={`${style['detached-wrapper']} ${colorStyle['bg--quaternary']}`}
                        >
                            <Container
                                pt={{ xs: 6, lg: 15 }}
                                pb={{ xs: 4, lg: 9 }}
                            >
                                <Row>
                                    {detachedGuides.map((guide, i) => (
                                        <Col
                                            key={i}
                                            col={{ lg: 4 }}
                                            pb={{ xs: 3 }}
                                            data-sal="slide-up"
                                            data-sal-easing="ease-out-quart"
                                            data-sal-delay={`xs-none--lg-${900 + (i % 3) * 200
                                                }`}
                                        >
                                            <CardGuideComponent {...guide} />
                                        </Col>
                                    ))}
                                </Row>
                            </Container>
                        </div>
                    ) : null
                }
            />
            <section ref={wrapperRef}>
                <Container pt={{ xs: 4 }} pb={{ xs: 4, lg: 12 }}>
                    <Row>
                        {filteredGuides && filteredGuides.length
                            ? filteredGuides.map((guide, i) => (
                                <Col
                                    key={i}
                                    col={{ md: 6, lg: 4 }}
                                    pb={{ xs: 3, lg: 6 }}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    data-sal-delay={`xs-none--lg-${(i % 3) * 200
                                        }`}
                                >
                                    <CardGuideComponent {...guide} />
                                </Col>
                            ))
                            : null}
                    </Row>
                </Container>
            </section>
        </>
    );
}
